module.exports = __webpack_public_path__ + "media/images/booking-bg-35484b525c6b3bd74911374061c17112.png";